import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { WwwDirectusService, TicketingQuantitiesContent } from 'www-cms';

export const ticketingQuantitiesContentResolver: ResolveFn<
  TicketingQuantitiesContent
> = (route, state) => {
  const directus = inject(WwwDirectusService);
  return directus.getTicketingQuantitiesContent();
};
